const autocompleteModalFilterService = {
  site: 'Sites',
  equipments: 'Equipment Type',
  equipmentGroups: 'Equipment Group',
  place: 'Local',
  area: 'Departments',
  serviceTypes: 'Service Type',
  companies: 'Third party company',
  frequencies: 'Frequency',
  performedBy: 'Performed by',
  doneInDelay: 'Show only services that were done late'
};

export default autocompleteModalFilterService;
